import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from "react";
import { Link as RouterLink } from "react-router-dom";
import Message from "../Message";
import { listStyles } from "../../actions/stylesActions";
import OccasionalCard from './OccasionalCard';
import "../Category.css";

const OccasionalStyle2 = () => {
  const dispatch = useDispatch();
  const { loading, error, styles } = useSelector((state) => state.styleList);

  useEffect(() => {
    dispatch(listStyles());
  }, [dispatch]);

  return (
    <div className="bg-[#F3F3FD]">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <p className="text-center text-xl font-semibold uppercase pt-8">
          Shop by Occasion
        </p>

        {loading ? (
          <div className="text-center py-10">Loading...</div>
        ) : error ? (
          <Message type="error">{error}</Message>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-6 py-10">
            {styles.map((catObj) => (
              <div key={catObj._id} className="flex justify-center">
                <OccasionalCard data={catObj} />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default OccasionalStyle2;
